import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from 'antd';
import { useEffect, useState } from 'react';
const FactoryAuditNotificationsDataTable = ({ data, tableDataItem, loading }) => {
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        if (data) {
            const newData = data.map((item, index) => {
                var _a, _b, _c;
                const formatDate = (dateString) => {
                    if (!dateString)
                        return '';
                    const [date] = dateString.split(' ');
                    return date;
                };
                return {
                    key: index,
                    factoryname: `${item.strFactoryName}`,
                    factoryaddress: `${item.strFactoryAddress}`,
                    product: `${(_a = item.objLuProductMainType) === null || _a === void 0 ? void 0 : _a.strLongDesc}`,
                    reportno: `${item.strFAReportNo}`,
                    certificatetype: `${(_b = item.objLuCertificationType) === null || _b === void 0 ? void 0 : _b.strLongDesc}`,
                    insdate: formatDate(item.dtInspectionDate),
                    issuedate: formatDate(item.dtIssueDate),
                    edate: formatDate(item.dtExpirationDate),
                    inspectionlevel: `${(_c = item.objLuFAInspectionLevel) === null || _c === void 0 ? void 0 : _c.strLongDesc}`,
                    relatedcertificates: `${item.intRelatedCertCount}`,
                };
            });
            setTableData(newData);
        }
    }, [data]);
    const columns = [
        {
            title: 'Factory Name',
            width: 120,
            dataIndex: 'factoryname',
            key: 'factoryname'
        },
        {
            title: 'Factory Address',
            width: 120,
            dataIndex: 'factoryaddress',
            key: 'factoryaddress'
        },
        {
            title: 'Product',
            width: 120,
            dataIndex: 'product',
            key: 'product'
        },
        {
            title: 'Report No',
            width: 120,
            dataIndex: 'reportno',
            key: 'reportno'
        },
        {
            title: 'Certification Type',
            width: 120,
            dataIndex: 'certificatetype',
            key: 'certificatetype'
        },
        {
            title: 'Inspection Date',
            width: 140,
            dataIndex: 'insdate',
            key: 'insdate'
        },
        {
            title: 'Issue Date',
            dataIndex: 'issuedate',
            key: 'issuedate',
            width: 120
        },
        {
            title: 'Expiration Date',
            width: 120,
            dataIndex: 'edate',
            key: 'edate'
        },
        {
            title: 'Inspection Level',
            width: 120,
            dataIndex: 'inspectionlevel',
            key: 'inspectionlevel'
        },
        {
            title: 'Related Certificates',
            width: 120,
            dataIndex: 'relatedcertificates',
            key: 'relatedcertificates'
        }
    ];
    return (_jsx(Table, { columns: columns, dataSource: tableDataItem ? [tableDataItem] : tableData, scroll: {
            x: 1400
        }, pagination: tableDataItem ? false : undefined, size: 'small', style: { borderRadius: '0px' }, loading: loading, sticky: { offsetHeader: 64 } }));
};
export default FactoryAuditNotificationsDataTable;
